import { render, staticRenderFns } from "./BaseBlock.vue?vue&type=template&id=0614c558&"
import script from "./BaseBlock.vue?vue&type=script&lang=ts&"
export * from "./BaseBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports